import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import { DragDropContext } from "react-beautiful-dnd";
import ReactTooltip from "react-tooltip";
import {
  CalendarEditorMonthsHeader,
  CalendarEditorMonthList,
} from "../CalendarEditor";
import { DevTool } from "@hookform/devtools";
import { Button, Icon } from "../../../_components";

export function CalendarMonthsPage({ onSubmit, formRef, store }) {
  const months = [...store.months];
  console.log("====Rendering CalMonthList");
  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    formState,
    watch,
    ...formMethods
  } = useForm({
    defaultValues: {
      months: months,
      // months: store.months || [],
      // months: gregorianCalendar.months.map((m, i) => ({ ...m, order: i })),
    },
  });

  const handleMonthAdd = () => {
    let { months: formMonths } = getValues() || { months: [] };
    if (!Array.isArray(formMonths)) formMonths = [];

    const newMonthItem = {
      name: "",
      days: 0,
      leapDays: 0,
      leapPeriod: 0,
    };

    const newMonths = [...formMonths, newMonthItem];

    setValue("months", newMonths);
    onSubmit({ months: newMonths });
    // document.activeElement.blur();
  };

  const handleMonthRemove = (month) => {
    console.log("DELETING MONTH");
    const newMonths = [...months.splice(0, month), ...months.splice(month + 1)];
    setValue("months", newMonths);
    onSubmit({ months: newMonths });
    // document.activeElement.blur();
  };

  // const { fields, move: moveMonth } = useFieldArray({
  //   control,
  //   name: "months",
  //   keyName: "rhf_id",
  // });

  // const months = watch("months");

  const handleDragEnd = (result) => {
    console.log("RESULT", result, months);
    const { destination, source } = result;
    if (!destination) return;
    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }
    // moveMonth(source.index, destination.index);
    // formRef.current.requestSubmit();
    const values = getValues();
    // console.log("formstate months", values.months);
    // const newMonths = Array.from(months);
    const newMonths = Array.from(values.months);
    // const newMonths = getValues("months");
    console.log("===NEW MONTHS", newMonths);
    // .sort((a, b) =>
    //   a.order > b.order ? -1 : 1
    // );
    // .map((m) => {
    //   return {
    //     name: m.namve,
    //     days: m.days,
    //     leapDays: m.leapDays,
    //     leapPeriod: m.leapPeriod,
    //   };
    // });
    const [movedMonth] = newMonths.splice(source.index, 1);
    newMonths.splice(destination.index, 0, movedMonth);
    // Accesses the form state, and updates newMonths with changed values...
    // const values = getValues();
    // console.log("formstate months", values.months);
    setValue("months", newMonths);
    onSubmit({ months: newMonths });
    document.activeElement.blur();
  };
  // useEffect(() => {
  //   getCalendar(store).month
  // })
  // const watchedMonths = watch("months");
  // console.log("WATCHED:  ", watchedMonths);
  const tooltipID = "chronosSetupModalTooltip";
  return (
    <div className="chronos-calendar-months-page">
      <FormProvider
        control={control}
        watch={watch}
        setValue={setValue}
        getValues={getValues}
        {...formMethods}
      >
        <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>
          <h2 className="chronos-wizard-page-title">Name your months</h2>
          <p className="chronos-wizard-text form-controls">
            <span>Customize your month names and duration.</span>
            <span>
              <Button onClick={handleMonthAdd} color="success">
                <Icon icon="fas fa-plus fa-fw" />
                &nbsp;Add Month
              </Button>
            </span>
          </p>
          <div className="chronos-calendar-editor">
            <DragDropContext onDragEnd={handleDragEnd}>
              <CalendarEditorMonthsHeader />
              <CalendarEditorMonthList
                items={months}
                onMonthDelete={handleMonthRemove}
              />
            </DragDropContext>
          </div>

          <ReactTooltip id={tooltipID} effect="solid" />
        </form>
        <DevTool control={control} />
      </FormProvider>
    </div>
  );
}
